import React from 'react';

export const pageMeta = {
  "name": "AJAX Applications",
  "link": "/javascript/ajax/applications"
};

export default function JavascriptAjaxApplications() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">AJAX Applications</h2>
      <p>Route: /javascript/ajax/applications</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
